// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-R":"R_cost-saving-R__kBcXP"};